import { normalize, schema } from 'normalizr';
import { processGlobalAnalyticsEvent } from '@pes-ui/utils';
import { getData } from '../utils';
const filter = new schema.Entity('filter', {}, {
  idAttribute: (value) => {
    const { navigationState, filterName } = value;
    return `${filterName}_${navigationState}`;
  },
  processStrategy: (value, parent) => {
    const { checked, count, disabled, label, filterName, navigationState, seoUrl, checkedURL, unCheckedURL, } = value;
    const { rootSectionId, parentCategoryId, nativeFilterCategory } = parent;
    return {
      label,
      value: `${filterName}_${navigationState}`,
      navigationState,
      seoUrl,
      count,
      isChecked: checked,
      isDisabled: disabled,
      rootSectionId,
      parentCategoryId,
      nativeFilterCategory,
      checkedURL,
      unCheckedURL,
    };
  },
});
const section = new schema.Entity('section', {
  filters: [filter],
}, {
  idAttribute: (value) => {
    const { filterCategory, filterSubCategory } = value;
    return filterSubCategory || filterCategory;
  },
  processStrategy: (value, parent) => {
    const { characteristicName, filterRefinements, subcharacteristics, filterCategory, filterSubCategory, nativeFilterCategory, } = value;
    const isMulti = value.filterRefinements.every((refinement) => typeof refinement.count === 'number');
    const { filterCategory: rootFilterCategory } = parent;
    return {
      name: characteristicName,
      isCollapsible: true,
      filters: filterRefinements,
      sections: subcharacteristics,
      rootSectionId: rootFilterCategory !== null && rootFilterCategory !== void 0 ? rootFilterCategory : filterCategory,
      parentCategoryId: filterSubCategory,
      nativeFilterCategory,
      type: isMulti ? 'multi' : 'single',
    };
  },
});
section.define({ sections: [section] });
const filters = [section];
export const normalizeFilters = (rawData) => {
  return normalize(rawData, filters);
};
export const clearNormalizedFilterData = (rawData) => {
  const { result, entities: { filter, section }, } = rawData;
  if (!filter || !section) {
    return null;
  }
  return {
    entities: {
      filter: Object.entries(filter).reduce((result, [key, value]) => {
        const newValue = Object.assign({}, value);
        ['parentCategoryId', 'navigationState'].forEach((keyToDelete) => {
          delete newValue[keyToDelete];
        });
        result[key] = newValue;
        return result;
      }, {}),
      section: Object.entries(section).reduce((result, [key, value]) => {
        const newValue = Object.assign({}, value);
        delete newValue.parentCategoryId;
        result[key] = newValue;
        return result;
      }, {}),
    },
    result,
  };
};
export const changeCategoriesFields = (parentFilterCategory, subcharacteristicsArray) => {
  return subcharacteristicsArray.forEach((item) => {
    item.nativeFilterCategory = item.filterCategory;
    item.filterCategory = parentFilterCategory;
    item.filterSubCategory = `${item.nativeFilterCategory}_${item.filterSubCategory}`;
    if (item.subcharacteristics.length > 0) {
      changeCategoriesFields(parentFilterCategory, item.subcharacteristics);
    }
  });
};
export const trackFilterAnalytics = (e, filtersNormalized) => {
  const { refinementId } = e.detail;
  const { value, nativeFilterCategory, parentCategoryId, rootSectionId, navigationState } = filtersNormalized.entities.filter[refinementId];
  const nativeParentCategoryId = parentCategoryId.slice(`${nativeFilterCategory}_`.length, parentCategoryId.length);
  const filterCategory = nativeFilterCategory || rootSectionId;
  const extraParams = {
    filterCategory,
    filterSubCategory: filterCategory !== nativeParentCategoryId ? nativeParentCategoryId : undefined,
    filterName: value.slice(0, value.indexOf(`_${navigationState}`)),
  };
  processGlobalAnalyticsEvent(e, extraParams);
};
function getCategories(filters) {
  var _a, _b;
  const categories = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters[0]) === null || _a === void 0 ? void 0 : _a.filterRefinements) !== null && _b !== void 0 ? _b : [];
  return categories.map(({ checked, checkedURL, label }) => ({
    checked,
    navigationState: checkedURL,
    label,
  }));
}
export async function fetchSprykerFilters(filtersUrl) {
  const response = await getData(false, filtersUrl);
  const { filters, pills, selectedFiltersQty } = response || {};
  let filtersNormalized;
  let filtrationSmartData;
  if (filters === null || filters === void 0 ? void 0 : filters.length) {
    filters.forEach((facet) => {
      facet.nativeFilterCategory = facet.filterCategory;
      changeCategoriesFields(facet.filterCategory, facet.subcharacteristics);
    });
    filtersNormalized = normalizeFilters(filters);
    filtrationSmartData = clearNormalizedFilterData(filtersNormalized);
  }
  const filtersCategories = getCategories(filters);
  return {
    filtersNormalized,
    filtrationSmartData,
    pills,
    filtersCategories,
    selectedSectionsCount: selectedFiltersQty,
    filters,
  };
}
